import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPlaybooksTemplatesRoute: InvariantJiraRoute = {
	name: 'project-settings-playbooks-templates',
	path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/templates',
	exact: true,
};
